import { eAtlas, ePublisherAPI, eSfxSprite, Game } from "../Game";
import { TimeManager } from "../Utils/Time/TimeManager";
import { Timer } from "../Utils/Time/Timer";
import { Ball, eKickOffResult } from "./Player/Ball";
import { GameCamera } from "./Camera";
import { DefenderManager } from "./Defenders/DefenderManager";
import { Goalie } from "./Goalie/Goalie";
import { HUD } from "./HUD/HUD";
import { eRoundMngState, RoundManager } from "./Round/RoundManager";
import { TargetManager } from "./Targets/TargetManager";
import { View } from "./View";
import { Shooter } from "./Player/Shooter";
import { GameplayTimer } from "./GameplayTimer";
import { ControlsC } from "./Player/ControlsC";
import { IUpdatableItem, UpdatableItemManager } from "../Utils/UpdatableItems";
import { TextPopup } from "./TextPopup";
import { Score } from "../Utils/Score";
import { Stadium } from "./Stadium/Stadium";
import * as Gamee from "./../Publisher API/Gamee/GameeWrapper";
import { RepData } from "../ReplayData";
import { eAnimMsgBgFx } from "./HUD/AnimMessages/AnimMessageManager";
import { ProtectedValue } from "../Utils/ProtectedValue";
import { ManCityIntro } from "./HUD/ManCityIntro";
import { LifeBar } from "./HUD/Arc8/Status bar/LifeBar";



export const TIME: TimeManager = new TimeManager();
export const TIMER: Timer = TIME.createTimer();



export const enum eGameplayState {
    /**
     * Probiha hra
     */
    play,
    /**
     * Zobrazuje se zprava Game Over
     */
    gameOverMessage,
    intro,
    /**
     * Zobrazuje se okno s vysledky po ukonceni hry
     */
    gameResults,

    gameOver,
    /**
     * Ceka se na start hry od 3rd API
     */
    waitForStart,
}



/**
 * Duvod ukonceni hry
 */
export const enum eGameEndReason {
    submit,
    outOfTime,
    outOfLives
}



export interface GameResults {
    score: number;
    remBallCnt: number;
    playTime: number;
    endReason: eGameEndReason;
}



export class Gameplay {
    /**
     * Udalost vyvolana pri zmene poctu zivotu
     * Parametry:
     * liveCnt: number Zbyvajici pocet zivotu
     */
    static readonly EVENT_LIFE_LOST = "game:lifeLost";
    /**
     * Udalost vyvolana po ukonceni hry
     */
    static readonly EVENT_GAME_END = "game:end";
    /**
     * Bonus za kazdy mic, ktery hraci zustane po dokonceni hry
     */
    static readonly EXTRA_BALL_SCORE = 1000;
    /**
     * Skore za gol bez zasahu terce
     */
    static readonly GOAL_SCORE = 10;

    static get instance(): Gameplay { return Gameplay._instance; }
    private static _instance: Gameplay;
    /**
     * Vysledky dokoncene hry
     */
    private _gameResults: GameResults;
    /**
     * (RO) Aktualni stav gameplay
     */
    get state(): eGameplayState { return this._state; }
    private _state: eGameplayState;
    /**
     * (RO) Spravce udalosti
     */
    get events(): pc.EventHandler { return this._events; }
    private _events: pc.EventHandler;
    /**
     * (RO) Odpocet casu hry
     */
    get timer(): GameplayTimer { return this._timer; }
    private _timer: GameplayTimer;
    private _timerStartTime: number;

    private _hud: HUD;
    private _camera: GameCamera;
    private _controls: ControlsC;
    private _roundMng: RoundManager;
    private _stadium: Stadium;
    private _goalie: Goalie;
    private _targets: TargetManager;
    private _defenders: DefenderManager;
    private _player: Shooter;

    get view(): View { return this._view; }
    private _view: View;

    get stadium(): Stadium { return this._stadium; }

    /**
     * (RO) Mic
     */
    get ball(): Ball { return this._ball; }
    private _ball: Ball;
    /**
     * Vyskakovaci zpravy se skore
     */
    get scorePopups(): UpdatableItemManager { return this._scorePopups; }
    private _scorePopups: UpdatableItemManager;
    /**
     * (RO) Skore
     */
    get score(): number { return this._score.value; }
    set score(val: number) {
        if (this._state == eGameplayState.play) {
            this._score.value = val;
        }
    }
    private _score: Score;
    /**
     * Cas posledni aktualizace skore (ziskany z TIMER.time)
     */
    private _scoreUpdateTime: number;
    /**
     * Cas poslany pri posledni aktualizaci skore
     */
    private _scoreTime: number;
    /**
     * (RO) Zbyvajici pocet micu
     */
    get lifeCnt(): number { return this._lifeCnt.value; }
    private _lifeCnt: ProtectedValue;
    /**
     * Pocet pauznuti hry
     */
    private _pauseCnt: ProtectedValue;
    /**
     * Replay data
     */
    private _repData: RepData;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        Gameplay._instance = this;

        this._events = new pc.EventHandler();
        this._timer = new GameplayTimer(Game.settings.timeLimit);

        // Zachytavat vyprseni casu hry
        this._events.on(GameplayTimer.EVENT_TIME_OUT, this.handleTimesUp, this);
        // Zachytavat vysledek letu mice
        this._events.on(Ball.EVENT_FLIGHT_END, this.handleBallFlightEnd, this);
        // Zachytavat pripraveni kola ke hre
        this._events.on(RoundManager.EVENT_ROUND_READY, this.handleRoundReady, this);

        this._lifeCnt = new ProtectedValue();
        this._pauseCnt = new ProtectedValue();

        this._view = new View();
        this._camera = new GameCamera();
        this._targets = new TargetManager();
        this._stadium = new Stadium();
        this._stadium.reset();
        this._score = new Score(1, this._events);
        this._scorePopups = new UpdatableItemManager(1, true, (): IUpdatableItem => { return new TextPopup(); }, this);
        this._hud = new HUD();
        this._goalie = new Goalie();
        this._defenders = new DefenderManager();
        this._player = new Shooter();
        this._ball = new Ball();
        this._controls = new ControlsC(this._ball);
        this._controls.activate();
        this._roundMng = new RoundManager();

        // Replay data
        if (Game.API == ePublisherAPI.ARC8)
            this._repData = new RepData();

        this.reset();

        // GAMEE
        if (Game.API == ePublisherAPI.ARC8 || Game.API == ePublisherAPI.PRIZES) {
            this._state = eGameplayState.waitForStart;
            this._hud.manCityIntro.show();

            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, () => {
                if (this._state != eGameplayState.waitForStart) {
                    this.reset();
                }
                else {
                    this._events.once(ManCityIntro.EVENT_COMPLETE, (): void => {
                        Game.playSound(eSfxSprite.whistle);
                        this._state = eGameplayState.play;
                        this._hud.handleRoundReady();
                    });
                    this._hud.manCityIntro.start(pc.platform.ios ? 1500 : 3000);
                    this._state = eGameplayState.intro;
                }

                Game.startAmbientAudio();
            }, this);
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.resume, () => {
                this._pauseCnt.value++;

                if (Game.settings.freePauseCnt >= 0 && this._pauseCnt.value > Game.settings.freePauseCnt) {
                    // Penalizace za pauzu
                    let score = this._score.value;

                    if (score > 0) {
                        let penalization = Game.settings.pausePenalty;
                        let compensation = 0;

                        if (penalization > score)
                            compensation = penalization - score;

                        this._score.value -= penalization;
                        this._events.fire(RepData.EVENT_PAUSE, compensation);
                    }
                }
            }, this);
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.submit, () => {
                this.gameOver(eGameEndReason.submit);
            }, this);
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.useExtraLife, () => {
                // Obnovit posledni zivot
                this._lifeCnt.value = 1;
                LifeBar.instance.reset();

                this._state = eGameplayState.play;
                this._roundMng.applyExtraLife();

                Game.startAmbientAudio();
            }, this);

            // Zachytavat - zmena skore
            this._events.on(Score.EVENT_SCORE_CHANGE, (score: Score, value: number) => {
                if (Game.API == ePublisherAPI.ARC8) {
                    this.updateGameeScore();
                }
                else if (Game.API == ePublisherAPI.PRIZES) {
                    Gamee.Wrapper.updateScore(value);
                }
            });
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        TIMER.start();

        if (Game.missions)
            Game.missions.resetMissionProgress();

        this._timer.reset();
        this._score.reset(0, 1);
        this._scoreUpdateTime = -1;
        this._pauseCnt.setToZero();
        this._lifeCnt.value = Game.settings.ballCnt;
        this._events.fire(RepData.EVENT_RESET);
        this._hud.reset();
        this._scorePopups.reset();
        this._stadium.reset();
        this._roundMng.reset();
        this.prepareRound();

        this._state = eGameplayState.play;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(): void {
        if (!this._timer.isStarted) {
            this._timer.start(this._timerStartTime);
            this._scoreUpdateTime = TIMER.time;

            if (Game.API == ePublisherAPI.ARC8 || Game.API == ePublisherAPI.PRIZES)
                Gamee.Wrapper.gameStart();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Pripravit kolo hry
     */
    //-------------------------------------------------------------------------
    prepareRound(): void {
        // Nastaveni kola
        this._roundMng.prepareRound();

        // Umistit mic
        this._ball.prepareKickOff();
        this._player.prepareKickOff();

        this._goalie.init();

        // Nastavit terce
        this._targets.init();

        // Nastavit obrance
        this._defenders.init();

        // Nastavit pozici kamery
        this._camera.reset();

        // Tribuna
        this._stadium.prepareNewRound();

        // Ovladani
        this._controls.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    gameOver(reason: eGameEndReason): void {
        if (this._state == eGameplayState.play) {
            // Zastavit mereni herniho casu
            this._timerStartTime = this._timer.startTime;
            this._timer.stop();

            // Vysledek hry
            let res: GameResults = {
                score: this._score.value,
                remBallCnt: this._lifeCnt.value,
                playTime: 0,
                endReason: reason
            }

            this._gameResults = res;

            // Pridat skore za extra zivoty
            if (reason == eGameEndReason.outOfTime) {
                let extraBallsBns = this._lifeCnt.value * Gameplay.EXTRA_BALL_SCORE;

                if (extraBallsBns != 0) {
                    this._score.value += extraBallsBns;
                }
            }
            else {
                res.remBallCnt = 0;
            }

            // Ulozit cas posledniho skore
            if (Game.API == ePublisherAPI.ARC8)
                this.updateGameeScore();

            res.playTime = this._scoreTime;

            // Zavrit replay data
            this._events.fire(RepData.EVENT_CLOSE, res);

            if (reason != eGameEndReason.submit) {
                // Zobrazit zpravu
                this._hud.animMessage.showMessage(0.5, eAnimMsgBgFx.failure, { atlas: Game.getAtlas(eAtlas.texts), frameKey: (reason == eGameEndReason.outOfLives ? "gameOver" : "timesOut") });
                this._state = eGameplayState.gameOverMessage;
            }
            else {
                // Zobrazit vysledky
                this.showResults();
            }

            // Vyvolat udalost
            this._events.fire(Gameplay.EVENT_GAME_END);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(deltaS: number): void {
        if (this._state >= eGameplayState.gameOver)
            return;

        TIME.update(deltaS);

        this._hud.update();

        if (this._state < eGameplayState.gameResults) {
            this._timer.update();
            this._roundMng.update();
            this._stadium.update();
            this._targets.update();
            this._ball.update();
            this._camera.update();
            this._goalie.update();
            this._player.update();
            this._scorePopups.update();
            this._controls.update();

            if (this._state == eGameplayState.gameOverMessage) {
                if (!this._hud.animMessage.isActive) {
                    // Zobrazit vysledky
                    this.showResults();
                    return;
                }
            }

            if (Game.API == ePublisherAPI.ARC8 && this._scoreUpdateTime >= 0 && this._scoreUpdateTime + 1000 < TIMER.time)
                this.updateGameeScore();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateGameeScore(): void {
        if (this._scoreUpdateTime >= 0) {
            if (this._repData.isOpen) {
                let score = this._score.value;

                this._scoreTime = Math.round(this._timer.elapsedTime);
                Gamee.Wrapper.updateScore(score, this._scoreTime, Game.calculateHash(score + ":" + this._scoreTime));
            }

            this._scoreUpdateTime = TIMER.time;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private showResults(): void {
        // Zastavit zvuk
        Game.stopAllSounds();

        if (Game.API == ePublisherAPI.ARC8) {
            // Zobrazit okno s vysledky
            this._hud.showResults(this._gameResults);
            this._state = eGameplayState.gameResults;
        }
        else {
            this._state = eGameplayState.gameOver;
            Gamee.Wrapper.gameOver();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat zmenu stavu kola
     */
    //-------------------------------------------------------------------------
    private handleRoundReady(): void {
        // Overit zda nevyprsel cas na hru
        if (this._state != eGameplayState.play || (this._timer.timeLimit > 0 && this._timer.timeLeft == 0)) {
            this.gameOver(eGameEndReason.outOfTime);
        }
        else {
            Game.playSound(eSfxSprite.whistle);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBallFlightEnd(res: eKickOffResult): void {
        if (this._state == eGameplayState.play) {
            if (res != eKickOffResult.target && res != eKickOffResult.goal) {
                // Snizit pocet zivotu
                this._events.fire(Gameplay.EVENT_LIFE_LOST, --this._lifeCnt.value);

                if (this._lifeCnt.value != 0)
                    // Zobrazit zpravu o neuspechu
                    this._hud.animMessage.showMessage(0.5, eAnimMsgBgFx.failure, { atlas: Game.getAtlas(eAtlas.texts), frameKey: "tryAgain" });
            }

            // Ukoncit kolo
            this._roundMng.endRound(res, this._lifeCnt.value);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTimesUp(): void {
        if (this._state == eGameplayState.play && this._roundMng.state != eRoundMngState.transToNextRound)
            this.gameOver(eGameEndReason.outOfTime);
    }
}